export default __webpack_public_path__ + "static/media/left-ar.9c4ff1d0.svg";